import { useMemo, useRef } from 'react';

import { useSearchFacetCounts } from '#/modules/search/contexts/SearchContext';

type AlgoliaFacetCounts = Record<string, Record<string, number>> | null;

export function useSearchFacetOptionsWithCounts(
  filterType: string,
  facets: { label: string; name: string }[],
) {
  const facetCounts = useSearchFacetCounts();

  const prevFacetCountsRef = useRef<AlgoliaFacetCounts>(null);

  const facetOptionsWithCounts = useMemo(() => {
    if (!facetCounts) {
      return facets;
    }

    prevFacetCountsRef.current ??= {};

    const countsForType =
      facetCounts[filterType] || prevFacetCountsRef.current[filterType] || {};

    prevFacetCountsRef.current = {
      ...facetCounts,
      [filterType]:
        facetCounts[filterType] || prevFacetCountsRef.current[filterType],
    };

    return facets.map(({ label, name }) => ({
      label: `${label} (${countsForType[name] || 0})`,
      name,
    }));
  }, [facetCounts, prevFacetCountsRef, facets, filterType]);

  return facetOptionsWithCounts;
}
